// // PRODUCTION SERVER
// export const BASE_URL = "https://tmsapi.raychemrpg.com/tms-core";

// // TESTING SERVER
export const BASE_URL = "https://tmstesting.raychemrpg.com/tms-core";

//export const BASE_URL = "http://tmstestingapi.scalent.io/tms-core";

// // Localhost
// export const BASE_URL = "http://localhost:8080/tms-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout API
export const LOGOUT = `${BASE_URL}/logout`;

// verify otp
export const VERIFY_OTP = `${BASE_URL}/verify-otp`;

// resend otp
export const RESEND_OTP = `${BASE_URL}/resend-otp`;

//visitor list
export const VISITOR_LIST = `${BASE_URL}/visitor/list`;
export const VISITOR = `${BASE_URL}/visitor/detail/`;

// trainee List
export const TRAINEE_LIST = `${BASE_URL}/trainee/list`;

// download QR code
export const DOWNLOAD_QR_CODE = `${BASE_URL}/trainee/download-qr/`;

//trainee details /add /edit /update
export const TRAINEE = `${BASE_URL}/trainee/`;

//trainee documents
export const TRAINEE_DOCUMENTS = `${BASE_URL}/trainee/prerequisite-documents/`

export const LETTER = `${BASE_URL}/letter/`;

export const LETTER_REQUEST_APPROVAL = `${BASE_URL}/letter/request-approval/`;

export const LETTER_TEMPLATE_CONTENT = `${BASE_URL}/letter-template-content/`;

export const DELETE_LETTER_USER = `${BASE_URL}/letter-user/`;

export const DOWNLOAD_LETTER_QR = `${BASE_URL}/letter/qr/`;

export const DOWNLOAD_LETTER = `${BASE_URL}/letter/download`;

export const GENERATE_FINAL_LETTER = `${BASE_URL}/letter/generate/`;

// super admin api's
export const SA_LETTERS_LIST = `${BASE_URL}/sa/letters`;

export const SA_LETTER_APPROVAL = `${BASE_URL}/sa/letter-approval`;

export const DELETE_TOOL_ITEMS = `${BASE_URL}/letter/delete-tool-items`;

//channel-partner
export const CHANNEL_PARTNER = `${BASE_URL}/channel-partner/`;
export const CHANNEL_PARTNER_LIST = `${BASE_URL}/channel-partner/list`;

//city and state list
export const STATE_LIST = `${BASE_URL}/state/list`;
export const CITY_LIST = `${BASE_URL}/city/list`;

export const ADD_CITY = `${BASE_URL}/city/`;

//instructor list
export const INSTRUCTOR_LIST = `${BASE_URL}/trainer/list`;
export const INSTRUCTOR = `${BASE_URL}/trainer/`;

// preRequisites documents
export const PREREQUISITES_DOCUMENT_LIST = `${BASE_URL}/prerequisite-document/list`;
export const PREREQUISITES_DOCUMENT = `${BASE_URL}/prerequisite-document/`;

//training center
export const TRAINING_CENTER = `${BASE_URL}/training-center/`;
export const TRAINING_CENTER_LIST = `${BASE_URL}/training-center/list`;

//change password
export const CHANGE_PASSWORD = `${BASE_URL}/user/change-password`;
//Reset Password
export const RESET_PASSWORD = `${BASE_URL}/user/reset-password`;

//course-category
export const COURSE_CATEGORY_LIST = `${BASE_URL}/course-category/list`;
export const COURSE_CATEGORY = `${BASE_URL}/course-category/`;

//admins
export const ADMIN = `${BASE_URL}/user/`;
export const ADMIN_LIST = `${BASE_URL}/user/list`;

//skills
export const SKILLS = `${BASE_URL}/skill/`;
export const SKILLS_LIST = `${BASE_URL}/skill/list`;

//tags
export const TAGS = `${BASE_URL}/tag/`;
export const TAGS_LIST = `${BASE_URL}/tag/list`;

//question-bank
export const QUESTION_BANK = `${BASE_URL}/question-bank/`;
export const QUESTION_BANK_LIST = `${BASE_URL}/question-bank/list`;
export const QUESTION_DIFFICULTY = `${BASE_URL}/question-difficulty-level/list`;

//question
export const QUESTION = `${BASE_URL}/question/`;

//batch
export const BATCH = `${BASE_URL}/batch/`;
export const BATCH_LIST = `${BASE_URL}/batch/list`;
export const ACTIVE_COURSE_NAME = `${BASE_URL}/course-name/active`;
export const COURSE_ENROLLMENT = `${BASE_URL}/batch/course-enrollment/`
export const BATCH_COURSE = `${BASE_URL}/batch/course/`;

//course
export const COURSE_NAME = `${BASE_URL}/course-name/`;
export const COURSE_NAME_LIST = `${BASE_URL}/course-name/all`;
export const COURSE_DOCUMENT = `${BASE_URL}/prerequisite-document/`;
export const COURSE_DOCUMENT_LIST = `${BASE_URL}/prerequisite-document/all`;

export const COURSE = `${BASE_URL}/course/`;
export const COURSE_LIST = `${BASE_URL}/course/list`;

//lessons
export const LESSON = `${BASE_URL}/lesson/`;
export const LESSON_COURSE = `${BASE_URL}/lesson/course/`;

//certificate-template
export const CERTIFICATE_TEMPLATE = `${BASE_URL}/certificate-template/`;
export const CERTIFICATE_TEMPLTE_LIST = `${BASE_URL}/certificate-template/list`;
export const SIGNATURE = `${BASE_URL}/signature/`;
export const SIGNATURE_LIST = `${BASE_URL}/signature/list`;

export const RECEIPT_LIST = `${BASE_URL}/receipt/list`;
export const RECEIPT_DOWNLOAD = `${BASE_URL}/receipt/`;

// Offline attendance module 
export const GET_COURSES_BATCHES = `${BASE_URL}/trainer/course-batches`;

// get lessons from courseId and batchId
export const GET_LESSONS = `${BASE_URL}/lessons`;

// add attendance
export const ADD_ATTENDANCE = `${BASE_URL}/attendance`;
export const GET_ATTENDANCE = `${BASE_URL}/admin/trainee-attendance`

//Payments
export const PAYMENT_LIST = "/enrollment/payments";
export const PAYMENT_DETAILS = "/enrollment/payments-details";

// get sessions list and data
export const GET_SESSION = `${BASE_URL}/sessions`;

//Approve/Reject Payment
export const APPROVE_REJECT_PAYMENT = "/enrollment/payments-approval";

// get batch schedule dates
export const BATCH_SCHEDULED_DATES = `${BASE_URL}/batches/`;

//assessment
export const ASSESSMENT = `${BASE_URL}/assessment/`;
export const ASSESSMENT_LIST = `${BASE_URL}/assessment/list`;

// get courses list for instructor login
export const INSTRUCTOR_COURSES = `${BASE_URL}/trainer/assigned-courses`;

export const INSTRUCTOR_BATCH_LIST = `${BASE_URL}/batch/trainer/assigned-batches`;

// admin and super admin courses and batches list
export const ADMINS_COURSES_AND_BATCHES = `${BASE_URL}/course/with-batches`;

// admin and super admin sessions list
export const ADMINS_SESSIONS_LIST = `${BASE_URL}/admin/sessions-list`;

// admin and super admin sessions wise attendance list
export const ADMINS_SESSIONS_WISE_ATTENDANCE_LIST = `${BASE_URL}/admin/sessions/`;

// channel partner courses and batches list
export const CHANNEL_PARTNER_COURSES_AND_BATCHES = `${BASE_URL}/channel-partner/course-batches/list`;

// channel partner sessions wise attendance list
export const CHANNEL_PARTNER_SESSIONS_WISE_ATTENDANCE_LIST = `${BASE_URL}/channel-partner/sessions/`;

// get  document approval list
export const DOCUMENT_APPROVALS = `${BASE_URL}/trainee/pending-document-approvals`;

// Assessment Artifacts
export const ASSESSMENT_ARTIFACT = `${BASE_URL}/assessment-artifact/`;
export const ASSESSMENT_ARTIFACT_LIST = `${BASE_URL}/assessment-artifact/list`;

// trainee assessment list 
export const TRAINEE_ASSESSMENT_LIST = `${BASE_URL}/trainee/`;
// trainee assessment artifact 
export const TRAINEE_ASSESSMENT_ARTIFACT_FILES = `${BASE_URL}/trainee/`;

// Course Ratings
export const COURSE_RATINGS = `${BASE_URL}/course-rating/trainee/`;
export const DELETE_COURSE_RATING = `${BASE_URL}/course-rating/`;

//Channel Partner Courses List and Details

export const CHANNEL_PARTNER_ENROLLED_COURSES_LIST = `${BASE_URL}/channel-partner/purchased-courses`;

export const CHANNEL_PARTNER_ENROLLED_COURSE_SCHEDULE = `${BASE_URL}/batch/channel-partner/trainee/schedule`;

//Enrolled course Review Details
export const ENROLLED_COURSE_REVIEWS = `${BASE_URL}/course-rating/trainee`;

//Attendance 
export const CHANNEL_PARTNER_TRAINEE_ENROLLED_COURSE_ATTENDANCE = `${BASE_URL}/attendance`

//course feedback
export const COURSE_RATING = `${BASE_URL}/course-rating/`;

//Upcoming Batches
export const CHANNEL_PARTNER_ENROLLED_COURSE_DETAILS = `${BASE_URL}/course`;

// Pending Enrolled Trainee List
export const PENDING_ENROLLED_TRAINEES_LIST = `${BASE_URL}/channel-partner/enrollment-pending-trainees/course`;

//Enrolled Trainee list against course
export const ENROLLED_TRAINEE_LIST_AGAINST_COURSE = `${BASE_URL}/course`;

//Upcoming Batches
export const UPCOMING_BATCHES = `${BASE_URL}/batch/course`;
// Admin profile 
export const ADMIN_PROFILE = `${BASE_URL}/user/profile`;

// Instructor profile 
export const INSTRUCTOR_PROFILE = `${BASE_URL}/trainer/profile`;

export const CHANNEL_PARTNER_COURSE_LIST = `${BASE_URL}/course/channel-partner/list`;

// channel-Partner-profile
export const CHANNEL_PARTNER_PROFILE = `${BASE_URL}/channel-partner/profile`;

//issuance
export const ISSUANCE_LIST = "batch/issuance/list";
export const ISSUANCE_ELIGIBLE_TRAINEES = `${BASE_URL}/course-certificate-template/eligible-trainees/`;
export const GENERATE_USER_CERTIFICATE = `${BASE_URL}/user-certificate/generate/`;
export const USER_CERTIFICATES_BATCH = `${BASE_URL}/user-certificate/batch/`;

// Payment Approval Request
export const PAYMENT_APPROVAL_REQUEST_LIST = `${BASE_URL}/trainee/payment-approval-request/list`;
// Trainee certificates
export const TRAINEE_CERTIFICATES = `${BASE_URL}/trainee/certificate-list/`;

// Save trainee certificate into jpg
export const TRAINEE_CERTIFICATE_IMAGE = `${BASE_URL}/user-certificate`;

//admin dashboard
export const ADMIN_DASHBOARD = `${BASE_URL}/admin-dashboard/summary`;

//channel partner dashboard
export const CHANNEL_PARTNER_DASHBOARD_SUMMARY = `${BASE_URL}/channel-partner-dashboard/summary`;

//channel partner reports
export const CHANNEL_PARTNER_COURSE_ENROLLMENT_REPORT = `${BASE_URL}/channel-partner-reports/course-enrollment`;

//admin reports
export const CERTIFICATE_ISSUANCE_REPORT = `${BASE_URL}/admin-reports/certificate-issuance`;

export const ATTENDANCE_REPORT = `${BASE_URL}/admin-reports/attendance`;

export const CERTIFICATE_PENDING_REPORT = `${BASE_URL}/admin-reports/certificate-pending`;

export const COURSE_ENROLLMENT_REPORT = `${BASE_URL}/admin-reports/course-enrollment`;

//instructor dashboard and reports
export const INSTRUCTOR_DASHBOARD_SUMMARY = `${BASE_URL}/trainer-dashboard/summary`;
export const INSTRUCTOR_DAILY_ATTENDANCE_REPORT = `${BASE_URL}/trainer-reports/daily-attendance`;
export const INSTRUCTOR_ASSESSMENT_REPORT = `${BASE_URL}/trainer-reports/assessment`;
